export default "__VITE_ASSET__DNakHOq0__"